import { render, staticRenderFns } from "./ProductSix.vue?vue&type=template&id=e918807e&"
import script from "./ProductSix.vue?vue&type=script&lang=js&"
export * from "./ProductSix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e918807e')) {
      api.createRecord('e918807e', component.options)
    } else {
      api.reload('e918807e', component.options)
    }
    module.hot.accept("./ProductSix.vue?vue&type=template&id=e918807e&", function () {
      api.rerender('e918807e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/products/ProductSix.vue"
export default component.exports